import { createSelector } from '@ngrx/store';
import { appSettingsState } from '../root';

export const getDeviceType = createSelector(appSettingsState, (appSettings) => appSettings?.deviceType);
